import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from '../constants/icon-register';
 
@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.registerIcons();
  }
 
  registerIcons(): void {
    const iconPath = ICONS.iconPath;
    const icons = ICONS.icons; // Add your icon names here
 
    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconPath}/${icon.fileName}.svg`)
      );
    });
  }
}